module.exports = __webpack_public_path__ + "img/presentation_site_lobbyx.d4ff8aef.webp";